import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../component/menu/Header";
import { constants } from "../constant/constants";
import SideMenu from "../component/menu/SideMenu";
import useUserStore from "../stores/store";
import CustomLoader from "../component/menu/CustomLoader";
import { Spin, Tabs } from "antd";
import DataNotFound from "../component/common/DataNotFound";
import '../styles/TabsStyle.css';
import AddFloorModal from "../component/modals/AddFloorModal";
import ConfirmModal from "../component/modals/ConfirmModal";
import DinningTableLists from "../component/table/DinningTableLists";
import Edit from "../component/images/Edit";
import DeleteIcon from "../component/images/DeleteClose";
import ApiService from "../utils/ApiService";
import DependencyModal from "../component/modals/DependencyModal";

function CustomTabLabel({ activeKey, item, onDelete, onEdit }) {

  const isActive = activeKey === item.id;

  const labelStyle = {
    backgroundColor: isActive ? '#1BA09C' : '#FFFFFF'
  }

  const onDeleteTab = (targetKey) => {
    onDelete(targetKey)
  }

  const onEditTab = (targetKey) => {
    onEdit(targetKey)
  }

  return (
    <div className="table-manage-label min-w-[100px]">
      <div className="flex space-x-[25px] justify-center pb-[2px]">
        <DeleteIcon
          attributes={{
            color: "#EE3169",
            size: "30",
            classes: "cursor-pointer ml-[7px]",
          }}
          clickHandler={() => onDeleteTab(item.id)}
        />
        <Edit attributes={{
          color: "#583986",
          size: "30",
          classes: "cursor-pointer mr-[12px]",
        }}
          clickHandler={() => onEditTab(item.id)}
        />
      </div>
      <div className={`h-[40px] px-2 rounded-t-[8px] py-3 border-t border-l border-r border-px border-[#d9d9d9]`} style={labelStyle}>
        {item.name}
      </div>
    </div>
  )
}

function AddTable() {
  const navigate = useNavigate();
  const params = useParams();
  const { restaurantId, branchId } = params;
  const { user, branches, setNetworkCall, showNotification } = useUserStore();

  const [tableLayoutLoading, setTableLayoutLoading] = useState(false);
  const [showAddModal, setShowAddModal] = useState({
    id: "",
    value: "",
    show: false
  });
  const [showConfirmModal, setShowConfirmModal] = useState({
    item: null,
    show: false
  });
  const [activeKey, setActiveKey] = useState('');
  const [items, setItems] = useState([]);
  const [floors, setFloors] = useState([]);
  const [dependencyObj, setDependencyObj] = useState({
    dependentOrders: []
  });
  const [openDependencyModal, setOpenDependencyModal] = useState(false);


  /*API call functions*/
  async function getFloorAndTableLayout(params) {
    const token = user.token.token;
    setNetworkCall(true);

    try {
      const res = await ApiService.GET_FLOOR_AND_TABLE_LAYOUT(params, token);
      if (!res || res.code !== 200) {
        showNotification(res?.message || "Failed to fetch restaurant branches");
        return;
      }

      const { payload } = res;
      if (payload.record) {
        setFloors(payload.record.floors)
      }
    } catch (err) {
      showNotification(err?.response?.data?.message || "Something went wrong");
    } finally {
      setNetworkCall(false);
    }
  }

  async function addOrEditFloorName(params) {
    const token = user.token.token;
    setNetworkCall(true);

    try {
      const res = await ApiService.ADD_OR_EDIT_FLOOR_NAME(params, token);
      if (!res || res.code !== 200) {
        showNotification(res?.message || "Failed to fetch restaurant branches");
        return;
      }
      const { payload } = res;
      // Updating records
      await getInitialRecords()
      setActiveKey(payload.record.id)
    } catch (err) {
      showNotification(err?.response?.data?.message || "Something went wrong");
    } finally {
      setNetworkCall(false);
    }
  }

  async function deleteFloorName(params) {
    const token = user.token.token;
    setNetworkCall(true);

    try {
      const res = await ApiService.DELETE_FLOOR_NAME(params, token);
      if (!res || res.code !== 200) {
        showNotification(res?.message || "Failed to fetch restaurant branches");
        return;
      }

      const {payload} = res;
      const {record} = payload
      const { dependentOrders, success } = record;
      if (!success) {
        setNetworkCall(false);
        setOpenDependencyModal(true);
        setDependencyObj(prev => ({
          ...prev,
          dependentOrders: dependentOrders
        }));
        return;
      }
      await getInitialRecords()
    } catch (err) {
      showNotification(err?.response?.data?.message || "Something went wrong");
    } finally {
      setNetworkCall(false);
    }
  }
  console.log('___dependencyObj.dependentOrders.length___', dependencyObj['dependentOrders'])

  /*API call functions*/

  /*Helper functions*/
  function processFloorLayouts(floors, currentActiveKey) {
    if (!floors || floors.length === 0) {
      setItems([]);
      setActiveKey("");
      return;
    }

    // 2. Check if the currentActiveKey from state is still valid
    const activeKeyIsValid = floors.some(floor => floor.id === currentActiveKey);
    let newActiveKey;

    // 3. Decide what the new activeKey should be
    if (activeKeyIsValid) {
      // The key from state is valid, so we'll use it
      newActiveKey = currentActiveKey;
    } else {
      // The key is invalid (not set, or was just deleted)
      // Default to the first item in the list
      newActiveKey = floors[0].id;
    }

    // 4. Set the initial activeKey *only if one isn't already set*
    if (currentActiveKey !== newActiveKey) {
      setActiveKey(newActiveKey);
    }

    const floorTabItems = floors.map((item) => {
      return {
        label: <CustomTabLabel activeKey={activeKey} item={item} onDelete={onDelete} onEdit={onEdit} />,
        name: item.name,
        key: item.id,
        children: <DinningTableLists
          data={{
            restaurantId: branchId,
            floorPlanName: item.name,
            floorPlanId: item.id,
            tables: item.tables,
            onSave: onSaveTables
          }}
          getInitialRecords={getInitialRecords} />
      }
    })
    setItems(floorTabItems);
  }

  async function getInitialRecords() {
    const params = {
      restaurantId: branchId
    };
    await getFloorAndTableLayout(params);
  }

  const add = async (value) => {
    setShowAddModal({ ...showAddModal, id: "", value: "", show: false })
    const param = {
      restaurantId: branchId,
      floorId: value.param.id,
      floorName: value.param.name,
    }
    await addOrEditFloorName(param);
  };

  const remove = async targetKey => {
    if (!items) {
      return;
    }
    const targetItem = items.find(item => item.key === targetKey);
    const param = {
      restaurantId: branchId,
      floorId: targetItem.key
    }
    setShowConfirmModal(false)
    await deleteFloorName(param)
  };

  const onEdit = (targetKey, action) => {
    if (action === 'add') {
      setShowAddModal({ ...showAddModal, id: "", value: "", show: true })
    }
    else {
      const selectedFloor = floors.find(floor => floor.id === targetKey);
      console.log(selectedFloor)
      setShowAddModal({ ...showAddModal, id: selectedFloor.id, value: selectedFloor.name, show: true })
    }
  };

  const onDelete = (targetKey) => {
    const selectedFloor = floors.find(floor => floor.id === targetKey);
    setShowConfirmModal({ ...showConfirmModal, item: selectedFloor, show: true })
  };

  const onTabChange = (key) => {
    setActiveKey(key);
  };

  const onSaveTables = async () => {
    await getInitialRecords()
  }
  /*Helper functions*/

  /*State management functions*/
  useEffect(() => {
    // 1. Define the async function inside
    async function fetchData() {
      await getInitialRecords();
    }

    // 2. Call the function
    fetchData();
  }, [])

  useEffect(() => {
    // Pass the *current* activeKey from state into the function
    processFloorLayouts(floors, activeKey);
  }, [floors, activeKey]);
  /*State management functions*/


  return (
    <div className="flex flex-col font-uregular">
      <Header title={`McDonalds Food Chain`} menu={constants.MENU.STAFF} currentMenuKey={"T_8_S_8"} />
      <CustomLoader />
      <div className="flex flex-row bg-prewhite">
        <SideMenu title={`McDonalds Food Chain`} menu={constants.MENU.STAFF} />
        <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[72px]">
          <div className="flex flex-col w-full">
            <div className="flex flex-col">
              {tableLayoutLoading ? (
                <div className="h-[70vh] flex items-center justify-center">
                  <Spin size="large" />
                </div>
              ) : (
                <div className="flex flex-col bg-[#FAFAFA]">
                  <div className="flex items-center justify-between mb-[28px]">
                    <div className="text-[24px]">Manage Table</div>
                    <div className="w-[100px] h-[40px]">
                      <button
                        className="w-full h-full bg-[#FFD700] text-[14px] font-bold leading-[16px] text-black rounded-[5px]"
                        onClick={() => navigate(`/restaurants/${restaurantId}/branch/${branchId}/floor-plan`)}
                      >
                        Back
                      </button>
                    </div>
                  </div>

                  <div className="table-management-tabs">
                    <Tabs
                      type="editable-card"
                      className="custom-tabs"
                      size="middle"
                      style={{ marginBottom: 32 }}
                      activeKey={activeKey}
                      onChange={onTabChange}
                      items={items}
                      onEdit={onEdit}
                    />
                  </div>
                </div>
              )}
            </div>
            <AddFloorModal
              openModal={showAddModal.show}
              records={{
                onFinish: add,
                onCancel: () => {
                  setShowAddModal({ ...showAddModal, show: false })
                },
                value: showAddModal.value,
                id: showAddModal.id
              }}
            />
            <ConfirmModal
              isModalOpen={showConfirmModal.show}
              centered
              records={{
                title: `Warning!!!`,
                message: `Are you sure, want to remove the ${showConfirmModal?.item?.name} floor plan?`,
                handleOk: () => remove(showConfirmModal.item.id),
                handleCancel: () => setShowConfirmModal({ ...showConfirmModal, show: false }),
                confirmText: "Yes",
                cancelconfirmText: "No",
                customStyle: {
                  top: 250
                },
              }}
            />

            {dependencyObj.dependentOrders.length > 0 && (
              <DependencyModal
                open={openDependencyModal}
                showOkButton={false}
                context="FLOOR_DEP"
                title="Please clean the following table(s) to delete!"
                dependentOrders={dependencyObj.dependentOrders}
                handleCancel={() => setOpenDependencyModal(false)}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddTable;
